var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2064B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.7,13c-0.3,0-0.6,0-0.9,0c-3.3-0.3-5.7-3.4-5.4-6.7c0.3-3,2.8-5.5,5.9-5.5l0,0c1.6-0.1,3.2,0.6,4.4,1.7 c2.5,2.2,2.5,6.2,0.3,8.6C14.9,12.2,13.3,12.9,11.7,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,22.3l-11.5,0c-0.5,0-1,0-1-0.6c0-4.4,3.6-7.9,8-7.9l3.1,0c0.7,0,1.4,0,2,0c3.7,0.3,6.6,3.1,7.2,6.7 c0.1,0.4,0.3,1.8-0.3,1.8l0,0c-0.3,0-0.6,0-0.9,0L13.8,22.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customer_icon.1d8b5123ef93908dc9d25ee42063a345.svg";
export { ForwardRef as ReactComponent };